/* eSM conferencing configuration file */
/* Defines endpoint URLs for conferencing */

var leica = leica || {};
leica.pi = leica.pi || {};
leica.pi.util = leica.pi.util || {};
leica.pi.util.conference = leica.pi.util.conference || {};

// public URLs that may differ in eSM vs Mustang/AIH
leica.pi.util.conference.viewerAssetsURL = "/getViewerAssets.php";
leica.pi.util.conference.viewerSettingsURL = "/getVilSettings.php";

leica.pi.util.conference.saveEntitiesURL = "/saveDscInvitation.php";
leica.pi.util.conference.getSetupDialogURL = "/AddDSC.php";
leica.pi.util.conference.saveDscURL = "/DSC_Save.php";
leica.pi.util.conference.setDscAvailabilityURL = "/DscAvail_Save.php";
leica.pi.util.conference.getDscAvailabilityURL = "/DscAvail_Get.php";

leica.pi.util.conference.getDscInviteURL = "/conference.blade.php";
leica.pi.util.conference.getDscInviteRequestURL = "/GetDsc.php";
leica.pi.util.conference.getDscInviteResponseURL = "/getDscInviteResponse.php";
leica.pi.util.conference.setDscInviteResponseURL = "/setDscInviteResponse.php";


